export const globalStyles = {
  colors: {
    primary: '#6E24D0',
    secondary: '#230051',
    transparent: 'transparent',
    black: '#000000',
    white: '#FFFFFF',
  },
  fontSizes: {
    xxs: 10,
    xs: 12,
    sm: 14,
    md: 16,
    lg: 18,
    xl: 20,
    xxl: 22,
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },
} as const;

export const iconStyles = {
  colors: {
    primary: '#637381',
    secondary: globalStyles.colors.primary,
  },
} as const;

export const dividerStyles = {
  colors: {
    primary: '#c4cdd5',
    secondary: '#dfe3e8',
  },
} as const;

export const borderStyles = {
  colors: {
    primary: '#c4cdd5',
    secondary: '#d9d9d9',
  },
} as const;

export const fontStyles = {
  colors: {
    primary: '#212b36',
    secondary: '#4e5b66',
    tertiary: '#637381',
  },
  sizes: globalStyles.fontSizes,
  weights: globalStyles.fontWeights,
} as const;

export const buttonStyles = {
  colors: {
    primary: globalStyles.colors.primary,
  },
};

export const backgroundStyles = {
  colors: {
    primary: globalStyles.colors.primary,
    secondary: globalStyles.colors.secondary,
    tertiary: '#d7d9db',
    quaternary: '#f8f9fa',
  },
} as const;
